import {
    FETCH_ANDROIDCLIENT,
    FETCH_ANDROIDCLIENTS,
} from '../actions/androidClient';


export const initialState = {
    isFetching: true,
    data: null
};

export const androidClients = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ANDROIDCLIENTS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ANDROIDCLIENTS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const androidClient = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ANDROIDCLIENT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ANDROIDCLIENT}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/androidClient.js